function randomLat() {
  var x = Math.random();
  if (0.63 < x && x < 0.9) {
    return 10 + x;
  } else {
    if (x > 0.9) {
      x = x - 0.123;
      return 10 + x;
    } else if (x < 0.63) {
      x = x + 0.2;
      if (0.63 < x && x < 0.9) {
        return 10 + x;
      } else {
        x = x + 0.25;
        if (0.63 < x && x < 0.9) {
          return 10 + x;
        } else {
          x = x + 0.2;
          return 10 + x;
        }
      }
    }
  }
}
function randomLng() {
  var x = Math.random();
  if (0.49 < x && x < 0.84) {
    return 106 + x;
  } else {
    if (x > 0.84) {
      x = x - 0.159;
      return 106 + x;
    } else if (x < 0.49) {
      x = x + 0.25;
      if (0.49 < x && x < 0.84) {
        return 106 + x;
      } else {
        x = x + 0.2;
        if (0.49 < x && x < 0.84) {
          return 106 + x;
        } else {
          x = x + 0.042;
          return 10 + x;
        }
      }
    }
  }
}

function randomPrice() {
  var x = Math.floor(Math.random() * 1000);
  return x + "k";
}

function randomRate() {
  var x = Math.floor(Math.random() * 50) / 10;
  if (x < 3) {
    x = x + 2;
  }
  return x;
}

function randomPic() {
  var x = Math.floor(Math.random() * 1000);
  if (x < 1) {
    x = x + 1;
  }
  return x;
}

const RoomData = [
  {
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,
    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },
  
  {
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },
  {
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },
  {
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },{
    mainPic: `https://source.unsplash.com/random/300x200?sig=${randomPic()}`,

    title: "Welcome to Ho Chi Minh",
    maxGuestNo: "3",
    roomNo: "1",
    bedNo: "2",
    rate: randomRate(),
    rateNo: "4.6",
    price: randomPrice(),
    lat: randomLat(),
    lng: randomLng(),
  },
];

export default RoomData;
